import { Component, HostBinding, Input } from '@angular/core';
import { FormErrorDirective } from './form-error.directive';

@Component({
  selector: 'form-error-message',
  template: '<ng-content></ng-content>',
})
export class FormErrorMessageComponent {
  @Input() public type: string;
  @HostBinding('hidden') public get isHidden(): boolean {
    const errors: string[] = Object.keys(this.container.control?.errors || {});
    return !errors.length || errors[0] !== this.type;
  }

  constructor(private container: FormErrorDirective) { }
}
